import { CustomException } from '@tencent/ppd-base-libs';
import { setUpWeixin, setWxShareInfo } from '@tencent/wphk-act-base-framework';

import { cacheFunc, to } from '@tencent/wphk-base-utils';
import { WxShareInfo } from '@tencent/wphk-base-wx';

// 缓存setupWeixin函数
const cacheSetupWeixin = cacheFunc(setUpWeixin);

/** 带缓存的初始化微信函数-可以感知微信初始化是否完成*/
export const setUpWeixinInit = async () => {
  const [err] = await to(cacheSetupWeixin());
  if (err) {
    new CustomException(err, 'setUpWeixinFail', '初始化微信分享失败');
  }
};

/** 设置微信分享内容 */
export const handleSetWxShareInfo = (wxShareConf: WxShareInfo) => {
  setWxShareInfo({
    wx: wxShareConf,
  });
};
